{
  "DATA_ASSISTANT": {
    "TITLE": "Podatkovni asistent",
    "NEW_CONVERSATION": "+ Nov",
    "LOADING": "Nalaganje ...",
    "LOADING_MESSAGES": "Nalaganje sporočil ...",
    "THINKING": "Razmišljanje ...",
    "UNTITLED": "Neimenovan pogovor",
    "NO_CONVERSATIONS": "Še ni pogovorov. Kliknite »+ Nov« za začetek.",
    "EMPTY_STATE": "Izberite pogovor ali ustvarite novega za začetek.",
    "PLACEHOLDER": "Kaj lahko poiščem za vas?",
    "SHOW_SQL": "Prikaži SQL",
    "NO_ROWS": "Ni vrnjenih vrstic.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Izbriši pogovor",
    "DELETE_CONFIRM_DESCRIPTION": "Ali ste prepričani, da želite izbrisati ta pogovor? Tega dejanja ni mogoče razveljaviti.",
    "DELETE_CONFIRM_YES": "Izbriši",
    "REPORTS": "Poročila",
    "SAVE_TO_REPORT": "Shrani v poročilo",
    "NEW_REPORT": "Novo poročilo",
    "REPORT_NAME": "Ime poročila",
    "NO_REPORTS": "Še ni shranjenih poročil",
    "REPORTS_EMPTY_STATE": "Izberite poročilo ali ustvarite novo.",
    "REPORT_SAVED": "Shranjeno v poročilo",
    "DELETE_REPORT_CONFIRM": "Izbriši poročilo",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Ali ste prepričani, da želite izbrisati to poročilo? Vsi shranjeni elementi bodo odstranjeni.",
    "DELETE_ITEM_CONFIRM": "Odstrani element",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Ali ste prepričani, da želite odstraniti ta element iz poročila?",
    "EXPORT_CSV": "Izvozi CSV",
    "REFRESH": "Osveži",
    "QUERY_RUNNING": "Izvajanje poizvedbe ...",
    "QUERY_FAILED": "Poizvedba ni uspela",
    "AUTO_REFRESH": "Samodejno osveževanje",
    "AUTO_REFRESH_NONE": "Ročno",
    "AUTO_REFRESH_30S": "30 sekund",
    "AUTO_REFRESH_1M": "1 minuta",
    "AUTO_REFRESH_5M": "5 minut",
    "AUTO_REFRESH_10M": "10 minut",
    "EDIT_MESSAGE": "Uredi sporočilo",
    "RENAME_REPORT": "Preimenuj poročilo",
    "RENAME_ITEM": "Preimenuj element",
    "MOVE_UP": "Premakni navzgor",
    "MOVE_DOWN": "Premakni navzdol",
    "COLLABORATORS": {
      "BUTTON": "Sodelavci",
      "TITLE": "Sodelavci poročila",
      "DESCRIPTION": "Izberite, kateri agenti in ekipe lahko vidijo to poročilo.",
      "AGENTS": "Agenti",
      "TEAMS": "Ekipe",
      "SELECT_AGENTS": "Izberite agente",
      "SELECT_TEAMS": "Izberite ekipe",
      "SAVE": "Shrani",
      "SAVED": "Sodelavci posodobljeni",
      "SAVE_FAILED": "Posodobitev sodelavcev ni uspela"
    }
  }
}
